import { Form, Field, useFormikContext } from "formik";
import {
  Button,
  Col,
  FormGroup,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import { BiRupee } from "react-icons/bi";
import styles from "./ExternalForm.module.scss";
import FileInputField from "../common/Form/FileInput";
import "react-datepicker/dist/react-datepicker.css";
import { OnlyNumberAllow, OnlyNumberLength } from "../../helpers";
import Loader from "../common/Loader/Loader";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MultiSelect from "../common/Form/Multiselect";
import { FiInfo } from "react-icons/fi";
import PhoneInputNumber from "../common/Form/MobileInput";
const ExternalApplicantForm = (props) => {
  const [citiesOption, setCitiesOption] = useState([]);
  const { errors, touched } = props;
  const { setFieldValue } = useFormikContext();
  const citiesData = useSelector((state) => state.jobProfiles.citiesData);
  useEffect(() => {
    if (citiesData && citiesData.length > 0) {
      const resVal = citiesData.map((val) => {
        return {
          value: val,
          label: val,
        };
      });
      resVal.unshift({value:"Remote",label:"Remote"})
      setCitiesOption(resVal);
    }
  }, [citiesData]);
  useEffect(() => {
    if (props?.ExternalData) {
      setFieldValue("location", props?.ExternalData?.location);
    }
  }, [props?.ExternalData]);
  return (
    <Form className={`${styles.ExternalForm}`} encType="multipart/form-data">
      <div className={styles.ExtenalFormMain}>
        <h1 className={styles.ExternalTitle}>Application Form</h1>
        <FormGroup className="form-group">
          <Row>
            <Col md={6}>
              <Label className={styles.formLabel}>First Name</Label>
              <Field className="form-control" name="name" maxlength='15' />
              {errors.name && touched.name ? (
                <div className={styles.formError}>{errors.name}</div>
              ) : null}
            </Col>
            <Col md={6}>
              <Label className={styles.formLabel}>Last Name</Label>
              <Field className="form-control" name="lastName" maxlength='15' />
            </Col>
          </Row>
        </FormGroup>
        <FormGroup className="form-group">
          <Row>
            <Col md={6}>
              <Label className={styles.formLabel}>Education</Label>
              <Field className="form-control" name="education" maxlength='20'/>
              {errors.education && touched.education ? (
                <div className={styles.formError}>{errors.education}</div>
              ) : null}
            </Col>
            <Col md={6}>
              <Label className={styles.formLabel}>Moblie</Label>
              {/* <Field
                className="form-control"
                onKeyPress={(event) => {
                  OnlyNumberAllow(event);
                }}
                name="phone"
                type="text"
              /> */}
              <PhoneInputNumber name="phone" autocomplete="off" maxlength='16' />
              {errors.phone && touched.phone ? (
                <div className={styles.formError}>{errors.phone}</div>
              ) : null}
            </Col>
          </Row>
        </FormGroup>

        {/* <FormGroup className="form-group">
          <Label className={styles.formLabel}>Position Type</Label>
          <Field className="form-control" as="select" name="position">
            <option value="" selected disabled>
              Select position
            </option>
            <option value="Full Time">Full Time</option>
            <option value="Part Time">Part Time</option>
            <option value="Intern">Intern</option>
            <option value="Contractual">Contractual</option>
          </Field>
          {errors.position && touched.position ? (
            <div className={styles.formError}>{errors.position}</div>
          ) : null}
        </FormGroup> */}
        <FormGroup className="form-group">
          <Label className={styles.formLabel}>Experience</Label>
          <Row>
            <Col md={6}>
              {/* <Label className={styles.formLabel}>Year</Label> */}
              <Field
                className="form-control"
                onKeyPress={(event) => {
                  OnlyNumberLength(event);
                }}
                maxlength="2"
                name="experienceYear"
                placeholder="Year"
              />
            </Col>
            <Col md={6}>
              {/* <Label className={styles.formLabel}>Month</Label> */}
              <Field
                className="form-control"
                name="experienceMonth"
                as="select"
              >
                <option value="" className="disableOption" selected disabled>Month</option>
                {Array.from(Array(12), (e, i) => {
                  return <option value={i}>{i}</option>;
                })}
              </Field>
            </Col>
          </Row>
        </FormGroup>
        <FormGroup className="form-group">
          <Row>
            <Col md={6}>
              <Label className={styles.formLabel}>Current CTC</Label>
              <InputGroup>
                <InputGroupText>
                  <BiRupee />{" "}
                </InputGroupText>
                <Field
                  className="form-control"
                  onKeyPress={(event) => {
                    OnlyNumberLength(event);
                  }}
                  maxlength="8"
                  name="currentCTC"
                />
              </InputGroup>
            </Col>
            <Col md={6}>
              <Label className={styles.formLabel}>Expected CTC</Label>
              <InputGroup>
                <InputGroupText>
                  <BiRupee />{" "}
                </InputGroupText>
                <Field
                  className="form-control"
                  onKeyPress={(event) => {
                    OnlyNumberLength(event);
                  }}
                  maxlength="8"
                  name="expectedCTC"
                />
              </InputGroup>
              {errors.expectedCTC && touched.expectedCTC ? (
                <div className={styles.formError}>{errors.expectedCTC}</div>
              ) : null}
            </Col>
          </Row>
        </FormGroup>
        <FormGroup className="form-group">
          <Label className={styles.formLabel}>Notice Period</Label>
          <Field className="form-control" name="noticePeriod" as="select">
            <option value="0">Immediate</option>
            <option value="0.5">15 Days</option>
            <option value="1">1 Month</option>
            <option value="2">2 Months</option>
            <option value="3">3 Months</option>
          </Field>
        </FormGroup>
        <FormGroup className="form-group">
          <Label className={styles.formLabel}>Email</Label>
          <Field className="form-control" name="email" type="email" maxlength='30' />
          {errors.email && touched.email ? (
            <div className={styles.formError}>{errors.email}</div>
          ) : null}
        </FormGroup>
        <FormGroup className="form-group">
          <Label className={styles.formLabel}>
            Resume <FiInfo className="infoIcon" title="Only pdf file up to 1 MB is allowed" />
          </Label>
          <FileInputField name="resume" />
          {errors.resume && touched.resume ? (
            <div className={styles.formError}>{errors.resume}</div>
          ) : null}
        </FormGroup>

        <FormGroup className="form-group">
          <Label className={styles.formLabel}>Preferred Location</Label>
          {citiesOption && citiesOption.length > 0 ? (
            <Field
              name="location"
              id="location"
              placeholder="Select Location"
              isMulti={false}
              component={MultiSelect}
              options={citiesOption}
              autocomplete="off"
            />
          ) : (
            <Field className="form-control" name="location" type="text" />
          )}
        </FormGroup>
      </div>
      <Button
        type="submit"
        disabled={props?.submited}
        className={styles.brandButton}
      >
        {props?.submited && <Loader height={30} width={30} color={"#FFFFFF"} />}
        Submit
      </Button>
    </Form>
  );
};

export default ExternalApplicantForm;
